// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: true,
  version: env.npm_package_version,
  serverUrl: 'https://api.wynk.com.br/api',
  accreditedServerUrl: 'https://accredited-api.wynk.com.br/api',
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'en-US',
    'fr-FR'
  ],
  firebase: {
    apiKey: 'AIzaSyCfDWoe0aNVWgzzRjQjpOcLfJu9S5frFwU',
    authDomain: 'wynk-31c4e.firebaseapp.com',
    databaseURL: 'https://wynk-31c4e.firebaseio.com',
    projectId: 'wynk-31c4e',
    storageBucket: 'wynk-31c4e.appspot.com',
    messagingSenderId: '397000068923'
  },
  firebaseEnv: '',
  chatbotUrl: 'https://bot.bluelab.com.br/wynk/chat/bot'
};



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/environments/environment.ts